import React from 'react';
import {
  Box, 
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import View from './View';
import Toolbar from './Toolbar';
import Api from '../../../Api';
import { useParams } from 'react-router-dom';

import { GetAuctionByID,ListWinnerGet,ProcessInvoice } from '../../../adminModel/auctions'
// import { Typography } from '@material-ui/core';
 
const useStyles = makeStyles((theme) => ({
  root: {
    background: `${Api.background.theme}`,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));


const EventView = () => {
 const classes = useStyles();
const { id } = useParams();
  const [auction, setAuction] = React.useState(null);
  const [loading, setLoading] = React.useState(true);


  const fetchData = async () => {
    setLoading(true); // Optional, show loading if needed
    try {
      const [auctionRes, winnerRes] = await Promise.all([
        GetAuctionByID(id),
        ListWinnerGet(id)
      ]);

      if (auctionRes?.id && Array.isArray(winnerRes)) {
        setAuction({
          ...auctionRes,
          winners: winnerRes
        });
      } else {
        console.error('Invalid data:', auctionRes, winnerRes);
      }
    } catch (err) {
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (id) fetchData();
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (!auction) return <p>No auction data found.</p>;


  return (
    <Page
      className={classes.root}
      title="Invoice"
    >
       <Container maxWidth={false}>
        <Toolbar auction_name={auction.auction_name}/>
        <Box mt={3}>
          <View winner={auction.winners} id={id} onRefresh={fetchData}/>
        </Box>
      </Container>
    </Page>
  );
};

export default EventView;
